import React, { FC } from "react"
import { graphql, PageProps } from "gatsby"
import MainLayout from "@layouts/MainLayout"
import Seo from "@components/Seo"
import components from "@components/Strapi"
import useThemeSwitch from "@hooks/useThemeSwitch"
import { PageContextProps } from "../types/types"

const PageTemplate: FC<PageProps<Queries.pageQuery, PageContextProps>> = ({
    data,
    location,
    pageContext
}) => {
    const { strapiPage: page } = data
    const sections = page?.sections

    useThemeSwitch()

    return <MainLayout>
        <Seo
            meta_title={page?.title}
            {...page?.seo}
            location={location}
            frontPage={pageContext?.frontPage}
        />

        {sections && sections.map((section, index) => {
            const Component = components[`${section?.__typename}`]
            const componentProps = { ...section, location }

            if (Component) {
                return <Component
                    key={`${section?.__typename}_${section?.id}`}
                    {...componentProps}
                    isFrontpage={!!pageContext?.frontPage}
                />
            }

            // eslint-disable-next-line react/no-array-index-key
            return <React.Fragment key={index}>
                {process.env.NODE_ENV !== "production" ? `Missing section: ${section?.__typename}` : ""}
            </React.Fragment>
        })}
    </MainLayout>
}

export default PageTemplate

export const pageQuery = graphql`
    query page($id: String!)
    {
        strapiPage(id:{eq: $id}) {
            title
            slug
            seo {
                ...Seo
            }
            sections {
                ...Hero
                ...Newsletter
                ...ContentSlides
                ...LatestNews
                ...Sponsors
                ...Content
                ...Positions
                ...Spacer
                ...FAQ
                ...CardsThreeColumns
                ...Gallery
                ...Video
                ...TwoColumns
                ...ContentCard
                ...RepeatableComponent
            }
        }
    }
`
